import { useState } from "react";
import { faqs } from "@/mocks/anime";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="section-pad bg-background-100/60">
      <div className="container-site grid gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="text-xs font-medium uppercase tracking-widest text-accent-600">FAQ</span>
          <h2 className="mt-1 font-heading text-3xl md:text-4xl">常见问题</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于卡通动漫综合免费看、高清画质、无广告与连播模式的疑问，这里都有答案。
          </p>
          <div className="mt-6 flex items-center gap-3 rounded-2xl border border-accent-200 bg-accent-100/60 p-4">
            <span className="grid h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-customer-service-2-line text-xl" />
            </span>
            <div>
              <p className="text-sm font-medium text-foreground-950">还有别的问题？</p>
              <a href="#contact" className="text-xs text-accent-700 hover:underline">
                联系客服，或查看页脚联系方式 →
              </a>
            </div>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="flex flex-col gap-3">
            {faqs.map((faq, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={faq.q}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-100"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : i)}
                    className="flex w-full items-center gap-3 px-5 py-4 text-left"
                  >
                    <span
                      className={`grid h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-medium ${
                        open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 font-heading text-base text-foreground-950">{faq.q}</span>
                    <i
                      className={`ri-arrow-down-s-line text-xl text-foreground-400 transition-transform duration-300 ${
                        open ? "rotate-180 text-primary-500" : ""
                      }`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-[60px] text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}